
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("f8Iqd", function(module, exports) {

$parcel$export(module.exports, "default", () => $182fb7a040953fe9$export$2e2bcd8739ae039);
/* error-boundary.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $gdv5Z = parcelRequire("gdv5Z");
var $iXCQx = parcelRequire("iXCQx");

var $7hXDW = parcelRequire("7hXDW");

var $ccHMk = parcelRequire("ccHMk");
var $7p4As = parcelRequire("7p4As");

var $4jR19 = parcelRequire("4jR19");
var $js7oX = parcelRequire("js7oX");

var $a3xa0 = parcelRequire("a3xa0");

var $h2l3D = parcelRequire("h2l3D");

var $2PqoT = parcelRequire("2PqoT");

var $kaECR = parcelRequire("kaECR");

var $dcO0p = parcelRequire("dcO0p");

var $iFil1 = parcelRequire("iFil1");

var $jIyl9 = parcelRequire("jIyl9");

var $gjGxN = parcelRequire("gjGxN");

var $kyZGY = parcelRequire("kyZGY");
function $182fb7a040953fe9$var$_defineProperty(e, r, t) {
    return (r = $182fb7a040953fe9$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $182fb7a040953fe9$var$_toPropertyKey(t) {
    var i = $182fb7a040953fe9$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $182fb7a040953fe9$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $182fb7a040953fe9$var$TRIGGER_SUBJECT = 'errorBoundary';
const $182fb7a040953fe9$var$ACTION_SUBJECT = 'rendered';
const $182fb7a040953fe9$var$styles = {
    robotsImg: "_4t3iuuw1",
    trelloErrorImg: "_1bsb11ux _4t3icmky",
    unverifiedUserImg: "_4t3i1w81",
    errorBoundaryBox: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _1bsb1vd0 _vchhusvi _1bah1h6o _2lx21bp4 _19pkoahv _otyroahv _19bvu2gc _u5f3u2gc",
    errorContent: "_1e0c1txw _4cvr1h6o _2lx21bp4 _y3gn1h6o",
    errorHeading: "_19pkxy5q",
    errorMessage: "_19pk1ejb",
    loginButton: "_19pk1ejb _1bah1h6o _1wpz1fhb"
};
const $182fb7a040953fe9$var$ErrorMessage = (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        xcss: $182fb7a040953fe9$var$styles.errorMessage,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
            as: "p",
            children: props.children
        })
    });
class $182fb7a040953fe9$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    componentDidCatch(error) {
        const reason = error instanceof (0, $iFil1.SwitcherLoadError) ? error.reason() : (0, $2PqoT.errorToReason)(error);
        this.setState({
            hasError: true,
            reason: reason
        }, ()=>{
            this.fireOperationalEvent({
                action: $182fb7a040953fe9$var$ACTION_SUBJECT,
                attributes: {
                    ...reason,
                    ...this.props.extraAnalyticProps
                }
            });
        });
        this.props.onErrorCallback?.(error);
    }
    renderErrorBody() {
        const { reason: reason } = this.state;
        if (!reason) return;
        if (reason.name === (0, $jIyl9.FETCH_ERROR_NAME)) {
            const isTrello = this.props.product === (0, $dcO0p.Product).TRELLO;
            if (reason.status === 401) // Not authorised http error
            return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gwFzn.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)($182fb7a040953fe9$var$ErrorMessage, {
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                            ...(0, $kaECR.default).errorTextLoggedOut
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                        xcss: $182fb7a040953fe9$var$styles.loginButton,
                        children: isTrello ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7p4As.default), {
                            href: (0, $h2l3D.getLoginUrl)((0, $dcO0p.Product).TRELLO),
                            onClick: this.handleLogin,
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                                ...(0, $kaECR.default).login
                            })
                        }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ccHMk.default), {
                            onClick: this.handleLogin,
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                                ...(0, $kaECR.default).login
                            })
                        })
                    })
                ]
            });
            if (reason.status === 403) return /*#__PURE__*/ (0, $7UHDa.jsx)($182fb7a040953fe9$var$ErrorMessage, {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $kaECR.default).errorTextUnverified
                })
            });
            return /*#__PURE__*/ (0, $7UHDa.jsx)($182fb7a040953fe9$var$ErrorMessage, {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $kaECR.default).errorTextNetwork
                })
            });
        }
        return /*#__PURE__*/ (0, $7UHDa.jsx)($182fb7a040953fe9$var$ErrorMessage, {
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...(0, $kaECR.default).errorText
            })
        });
    }
    renderErrorHeading() {
        const { reason: reason } = this.state;
        if (!reason) return;
        if (reason.name === (0, $jIyl9.FETCH_ERROR_NAME) && reason.status === 401) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $kaECR.default).errorHeadingLoggedOut
        });
        if (reason.name === (0, $jIyl9.FETCH_ERROR_NAME) && reason.status === 403) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $kaECR.default).errorHeadingUnverified
        });
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $kaECR.default).errorHeading
        });
    }
    renderErrorImage() {
        const { intl: intl, product: product } = this.props;
        const { reason: reason } = this.state;
        if (product === (0, $dcO0p.Product).TRELLO) return /*#__PURE__*/ (0, $7UHDa.jsx)("img", {
            src: (0, $gjGxN.default),
            alt: intl.formatMessage((0, $kaECR.default).errorImageAltText),
            className: (0, $35pXk.default)([
                $182fb7a040953fe9$var$styles.trelloErrorImg
            ])
        });
        if (reason.status === 403) return /*#__PURE__*/ (0, $7UHDa.jsx)("img", {
            src: (0, $kyZGY.default),
            alt: intl.formatMessage((0, $kaECR.default).errorImageAltText),
            className: (0, $35pXk.default)([
                $182fb7a040953fe9$var$styles.unverifiedUserImg
            ])
        });
        return /*#__PURE__*/ (0, $7UHDa.jsx)($182fb7a040953fe9$var$RobotImage, {
            alt: intl.formatMessage((0, $kaECR.default).errorImageAltText),
            className: (0, $35pXk.default)([
                $182fb7a040953fe9$var$styles.robotsImg
            ])
        });
    }
    render() {
        const { hideFallbackUI: hideFallbackUI, children: children } = this.props;
        const { hasError: hasError } = this.state;
        if (hasError && hideFallbackUI) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {});
        if (hasError) return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
            "data-testid": "error-boundary",
            className: (0, $35pXk.default)([
                $182fb7a040953fe9$var$styles.errorBoundaryBox
            ]),
            children: /*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
                className: (0, $35pXk.default)([
                    $182fb7a040953fe9$var$styles.errorContent
                ]),
                children: [
                    this.renderErrorImage(),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                        xcss: $182fb7a040953fe9$var$styles.errorHeading,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7hXDW.default), {
                            size: "medium",
                            children: this.renderErrorHeading()
                        })
                    }),
                    this.renderErrorBody()
                ]
            })
        });
        return children;
    }
    constructor(...args){
        super(...args);
        $182fb7a040953fe9$var$_defineProperty(this, "state", {
            hasError: false
        });
        $182fb7a040953fe9$var$_defineProperty(this, "fireOperationalEvent", (payload)=>{
            if (this.props.createAnalyticsEvent) this.props.createAnalyticsEvent({
                eventType: (0, $a3xa0.OPERATIONAL_EVENT_TYPE),
                actionSubject: this.props.triggerSubject || $182fb7a040953fe9$var$TRIGGER_SUBJECT,
                ...payload
            }).fire((0, $a3xa0.NAVIGATION_CHANNEL));
        });
        $182fb7a040953fe9$var$_defineProperty(this, "handleLogin", (_, analyticsEvent)=>{
            analyticsEvent.update({
                eventType: (0, $a3xa0.UI_EVENT_TYPE),
                actionSubjectId: 'login'
            }).fire((0, $a3xa0.NAVIGATION_CHANNEL));
            if (this.props.product !== (0, $dcO0p.Product).TRELLO) window.location.reload();
        });
    }
}

const $182fb7a040953fe9$var$RobotImage = (props)=>{
    const [imgSrc, setImgSrc] = (0, $gwFzn.useState)();
    (0, $gwFzn.useEffect)(()=>{
        (parcelRequire("aOgb2")).then((src)=>setImgSrc(src.default));
    }, []);
    return /*#__PURE__*/ (0, $7UHDa.jsx)("img", {
        alt: "",
        ...props,
        src: imgSrc
    });
};
var $182fb7a040953fe9$export$2e2bcd8739ae039 = (0, $a3xa0.withAnalyticsEvents)()((0, $js7oX.default)($182fb7a040953fe9$var$ErrorBoundary));

});
parcelRegister("h2l3D", function(module, exports) {

$parcel$export(module.exports, "getLoginUrl", () => $3d203fedbb962cbf$export$8abe2e83e8d74da2);

var $dcO0p = parcelRequire("dcO0p");
var $3d203fedbb962cbf$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["Staging"] = "stg";
    Environment["Production"] = "prod";
    return Environment;
}({});
const $3d203fedbb962cbf$export$186d9db1ec46a9ca = (origin = window?.location?.origin)=>[
        'https://trello.com'
    ].includes(origin) ? "prod" : "stg";
const $3d203fedbb962cbf$var$getProduct = (product)=>{
    if (product) {
        const lowerJira = (0, $dcO0p.Product).JIRA.toLowerCase();
        const lowerProduct = product.toLowerCase();
        if (lowerProduct.includes(lowerJira)) return lowerJira;
        return lowerProduct;
    }
};
const $3d203fedbb962cbf$export$8abe2e83e8d74da2 = (productType, env = $3d203fedbb962cbf$export$186d9db1ec46a9ca(), continueUrl = String(window.location), loginHint)=>{
    const baseUrl = env === "prod" ? 'https://id.atlassian.com/login' : 'https://id.stg.internal.atlassian.com/login';
    const product = $3d203fedbb962cbf$var$getProduct(productType);
    return `${baseUrl}?continue=${encodeURIComponent(continueUrl)}${product ? `&application=${encodeURIComponent(product)}` : ''}
  ${loginHint ? `&login_hint=${encodeURIComponent(loginHint)}` : ''}`;
};

});

parcelRegister("kaECR", function(module, exports) {

$parcel$export(module.exports, "default", () => $952538c0e85b84fa$export$2e2bcd8739ae039);

var $2nPZH = parcelRequire("2nPZH");
const $952538c0e85b84fa$var$messages = (0, $2nPZH.defineMessages)({
    emptyStateExploreProductsTitle: {
        id: "fabric.atlassianSwitcher.emptyState.exploreProducts.title",
        defaultMessage: "Get started with cloud"
    },
    emptyStateExploreProductsBody: {
        id: "fabric.atlassianSwitcher.emptyState.exploreProducts.body",
        defaultMessage: "Try a product to start collaborating with your team."
    },
    emptyStateExploreProductsLink: {
        id: "fabric.atlassianSwitcher.emptyState.exploreProducts.link",
        defaultMessage: "Explore products"
    },
    home: {
        id: "fabric.atlassianSwitcher.atlassianHome",
        defaultMessage: "Home"
    },
    atlassianHome: {
        id: "fabric.atlassianSwitcher.home",
        defaultMessage: "Atlassian Home"
    },
    atlassianStart: {
        id: "fabric.atlassianSwitcher.start",
        defaultMessage: "Atlassian Start"
    },
    assets: {
        id: "fabric.atlassianSwitcher.assets",
        defaultMessage: "Assets"
    },
    analytics: {
        id: "fabric.atlassianSwitcher.analytics",
        defaultMessage: "Analytics"
    },
    companyHub: {
        id: "fabric.atlassianSwitcher.companyHub",
        defaultMessage: "Company Hub"
    },
    goals: {
        id: "fabric.atlassianSwitcher.goals",
        defaultMessage: "Goals"
    },
    teams: {
        id: "fabric.atlassianSwitcher.teams",
        defaultMessage: "Teams"
    },
    search: {
        id: "fabric.atlassianSwitcher.search",
        defaultMessage: "Search"
    },
    chat: {
        id: "fabric.atlassianSwitcher.chat",
        defaultMessage: "Chat"
    },
    studio: {
        id: "fabric.atlassianSwitcher.studio",
        defaultMessage: "Studio"
    },
    more: {
        id: "fabric.atlassianSwitcher.more",
        defaultMessage: "More"
    },
    manageList: {
        id: "fabric.atlassianSwitcher.manageList",
        defaultMessage: "Manage list"
    },
    jiraProject: {
        id: "fabric.atlassianSwitcher.jiraProject",
        defaultMessage: "Jira project"
    },
    confluenceSpace: {
        id: "fabric.atlassianSwitcher.confluenceSpace",
        defaultMessage: "Confluence space"
    },
    errorEmptyPartialResults: {
        id: "fabric.atlassianSwitcher.errorEmptyPartialResults",
        defaultMessage: "We can't display your apps right now."
    },
    errorHeading: {
        id: "fabric.atlassianSwitcher.errorHeading",
        defaultMessage: "Something\u2019s gone wrong"
    },
    errorText: {
        id: "fabric.atlassianSwitcher.errorText",
        defaultMessage: "We keep track of these errors, but feel free to contact us if refreshing doesn\u2019t fix things"
    },
    errorImageAltText: {
        id: "fabric.atlassianSwitcher.errorImageAltText",
        defaultMessage: "A broken robot and a number of people busy fixing it."
    },
    errorTextNetwork: {
        id: "fabric.atlassianSwitcher.errorTextNetwork",
        defaultMessage: "We couldn\u2019t load this list. Please reload the page and try again."
    },
    errorHeadingLoggedOut: {
        id: "fabric.atlassianSwitcher.errorHeadingLoggedOut",
        defaultMessage: "Your Atlassian account is logged out"
    },
    errorTextLoggedOut: {
        id: "fabric.atlassianSwitcher.errorTextLoggedOut",
        defaultMessage: "Log in again to use the Atlassian switcher."
    },
    errorHeadingUnverified: {
        id: "fabric.atlassianSwitcher.errorHeadingUnverified",
        defaultMessage: "Your account is unverified"
    },
    errorPartialResults: {
        id: "fabric.atlassianSwitcher.errorPartialResults",
        defaultMessage: "We can't display some of your apps right now."
    },
    errorPartialResultsRefresh: {
        id: "fabric.atlassianSwitcher.errorPartialResultsRefresh",
        defaultMessage: "Refresh the page, or try again later."
    },
    errorTextUnverified: {
        id: "fabric.atlassianSwitcher.errorTextUnverified",
        defaultMessage: "Please confirm your email address to view a list of available products."
    },
    login: {
        id: "fabric.atlassianSwitcher.login",
        defaultMessage: "Log in"
    },
    productDescriptionConfluence: {
        id: "fabric.atlassianSwitcher.product.description.confluence",
        defaultMessage: "Document collaboration"
    },
    productDescriptionJiraServiceManagement: {
        id: "fabric.atlassianSwitcher.product.description.jsm",
        defaultMessage: "Collaborative IT service management"
    },
    productDescriptionJiraSoftware: {
        id: "fabric.atlassianSwitcher.product.description.jsw",
        defaultMessage: "Project and issue tracking"
    },
    productDescriptionOpsgenie: {
        id: "fabric.atlassianSwitcher.product.description.opsgenie",
        defaultMessage: "Modern incident management"
    },
    productDescriptionCompass: {
        id: "fabric.atlassianSwitcher.product.description.compass",
        defaultMessage: "Component manager"
    },
    join: {
        id: "fabric.atlassianSwitcher.join",
        defaultMessage: "Join"
    }
});
var $952538c0e85b84fa$export$2e2bcd8739ae039 = $952538c0e85b84fa$var$messages;

});

parcelRegister("iFil1", function(module, exports) {

$parcel$export(module.exports, "SwitcherLoadErrorReason", () => $4775a99414f4d2cc$export$2c6136f6e27d3fdd);
$parcel$export(module.exports, "SwitcherLoadError", () => $4775a99414f4d2cc$export$ff0950b3c2e7f03e);

var $2PqoT = parcelRequire("2PqoT");
var $4775a99414f4d2cc$export$2c6136f6e27d3fdd = /*#__PURE__*/ function(SwitcherLoadErrorReason) {
    SwitcherLoadErrorReason["AVAILABLE_PRODUCTS"] = "availableProducts";
    SwitcherLoadErrorReason["PRODUCT_CONFIGURATION"] = "productConfiguration";
    return SwitcherLoadErrorReason;
}({});
class $4775a99414f4d2cc$export$ff0950b3c2e7f03e extends Error {
    reason() {
        const potentialResultError = this.resultError;
        return {
            ...(0, $2PqoT.errorToReason)(potentialResultError.error ? potentialResultError.error : this.resultError),
            source: this.errorReason
        };
    }
    constructor(errorReason, resultError){
        super();
        this.errorReason = void 0;
        this.resultError = void 0;
        this.errorReason = errorReason;
        this.resultError = resultError;
    }
}

});

parcelRegister("gjGxN", function(module, exports) {

$parcel$export(module.exports, "default", () => $9790e8d4108f316a$export$2e2bcd8739ae039);
var $9790e8d4108f316a$export$2e2bcd8739ae039 = 'data:image/svg+xml;base64,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';

});

parcelRegister("kyZGY", function(module, exports) {

$parcel$export(module.exports, "default", () => $de5b305fb7390b41$export$2e2bcd8739ae039);
var $de5b305fb7390b41$export$2e2bcd8739ae039 = `data:image/svg+xml;base64,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`;

});

parcelRegister("aOgb2", function(module, exports) {

let $7deb1f4b46250de3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7deb1f4b46250de3$var$load("2PUw9").then(()=>parcelRequire('6hgg7'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});

parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});




parcelRegister("eycgM", function(module, exports) {

$parcel$export(module.exports, "SwitcherExperimentProvider", () => $de14f99adc16bc86$export$cd11e4cf103a20cf);
$parcel$export(module.exports, "useSwitcherTeam25Experiment", () => $de14f99adc16bc86$export$f0a8b7930250858a);
$parcel$export(module.exports, "useIsSwitcherTeam25TestCohort", () => $de14f99adc16bc86$export$3b522177296bf82b);
$parcel$export(module.exports, "useSwitcherOverflowExperiment", () => $de14f99adc16bc86$export$e16f6a57624d19e2);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
// Temporary fix to enable the Growth team’s app recommendation section to access our experiment.
// TODO: https://hello.jira.atlassian.cloud/browse/NAVX-350
const $de14f99adc16bc86$var$storageKey = '@atlassian/switcher-team-25-experiment-cohort';
const $de14f99adc16bc86$export$fcdf652c4fd8e4c7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext(undefined);
const $de14f99adc16bc86$export$cd11e4cf103a20cf = ({ children: children })=>{
    const [switcherTeam25ExperimentCohort, setSwitcherTeam25ExperimentCohort] = (0, $gwFzn.useState)();
    const [switcherOverflowExperimentCohort, setSwitcherOverflowExperimentCohort] = (0, $gwFzn.useState)();
    const contextValue = (0, $gwFzn.useMemo)(()=>({
            switcherTeam25ExperimentCohort: switcherTeam25ExperimentCohort,
            setSwitcherTeam25ExperimentCohort: setSwitcherTeam25ExperimentCohort,
            switcherOverflowExperimentCohort: switcherOverflowExperimentCohort,
            setSwitcherOverflowExperimentCohort: setSwitcherOverflowExperimentCohort
        }), [
        switcherTeam25ExperimentCohort,
        setSwitcherTeam25ExperimentCohort,
        switcherOverflowExperimentCohort,
        setSwitcherOverflowExperimentCohort
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (window?.sessionStorage && switcherTeam25ExperimentCohort) window.sessionStorage.setItem($de14f99adc16bc86$var$storageKey, switcherTeam25ExperimentCohort);
    }, [
        switcherTeam25ExperimentCohort
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($de14f99adc16bc86$export$fcdf652c4fd8e4c7.Provider, {
        value: contextValue,
        children: children
    });
};
const $de14f99adc16bc86$export$3135e38521020087 = ()=>(0, $gwFzn.useContext)($de14f99adc16bc86$export$fcdf652c4fd8e4c7);
const $de14f99adc16bc86$export$f0a8b7930250858a = ()=>{
    const experimentContext = $de14f99adc16bc86$export$3135e38521020087();
    return {
        cohort: experimentContext?.switcherTeam25ExperimentCohort,
        setTeam25Cohort: experimentContext ? experimentContext.setSwitcherTeam25ExperimentCohort : ()=>{}
    };
};
const $de14f99adc16bc86$export$3b522177296bf82b = ()=>{
    const { cohort: cohort } = $de14f99adc16bc86$export$f0a8b7930250858a();
    if (cohort) return cohort === 'test';
    // fallback to session storage
    return window?.sessionStorage?.getItem($de14f99adc16bc86$var$storageKey) === 'test';
};
const $de14f99adc16bc86$export$e16f6a57624d19e2 = ()=>{
    const experimentContext = $de14f99adc16bc86$export$3135e38521020087();
    return {
        cohort: experimentContext?.switcherOverflowExperimentCohort,
        setOverflowCohort: experimentContext ? experimentContext.setSwitcherOverflowExperimentCohort : ()=>{}
    };
};

});

parcelRegister("hhh77", function(module, exports) {

$parcel$export(module.exports, "FadeIn", () => $84079bfb5c128ee4$export$bd7370ffb2917ab7);
/* fade-in.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");
parcelRequire("gwFzn");
const $84079bfb5c128ee4$var$fadeIn = null;
const $84079bfb5c128ee4$var$fadeInStyles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _j7hq16na _5sag1bs3 _1pgl5ucs _1o51q7pw _tzy4idpf _syaz1fxt"
};
const $84079bfb5c128ee4$export$bd7370ffb2917ab7 = ({ children: children, className: className, tag: Tag = 'div' })=>/*#__PURE__*/ (0, $7UHDa.jsx)(Tag, {
        className: (0, $35pXk.default)([
            $84079bfb5c128ee4$var$fadeInStyles.root,
            className
        ]),
        children: children
    });

});

parcelRegister("6FJLn", function(module, exports) {

$parcel$export(module.exports, "default", () => $742bf36fd641c4cb$export$2e2bcd8739ae039);
/* themed-item.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $lYygP = parcelRequire("lYygP");
// temp workaround to fix mix usage of emotion and compiled css: https://hello.jira.atlassian.cloud/browse/NAVX-551
const $742bf36fd641c4cb$var$styles = {
    item: "_2rko1mmr _ca0q1a66 _u5f31a66 _n3td1a66 _19bv1a66",
    icon: "_2hwxr5cr"
};
var $742bf36fd641c4cb$export$2e2bcd8739ae039 = (props)=>{
    const { icon: icon, ...rest } = props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lYygP.default), {
        icon: /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
            className: (0, $35pXk.default)([
                $742bf36fd641c4cb$var$styles.icon
            ]),
            children: icon
        }),
        ...rest,
        className: (0, $35pXk.default)([
            $742bf36fd641c4cb$var$styles.item
        ])
    });
};

});
parcelRegister("lYygP", function(module, exports) {

$parcel$export(module.exports, "LozengeType", () => $53dd823c995635cb$export$b95b532653e2b7f6);
$parcel$export(module.exports, "default", () => $53dd823c995635cb$export$2e2bcd8739ae039);
/* item.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $cGtPE = parcelRequire("cGtPE");

var $a3xa0 = parcelRequire("a3xa0");

var $hhh77 = parcelRequire("hhh77");

var $5nBzc = parcelRequire("5nBzc");

var $4jR19 = parcelRequire("4jR19");

var $d3Dtl = parcelRequire("d3Dtl");

var $f8Iqd = parcelRequire("f8Iqd");
var $53dd823c995635cb$export$b95b532653e2b7f6 = /*#__PURE__*/ function(LozengeType) {
    LozengeType["New"] = "new";
    LozengeType["NewBold"] = "new_bold";
    LozengeType["Try"] = "try";
    return LozengeType;
}({});
const $53dd823c995635cb$var$lozengeData = {
    ["new"]: {
        label: (0, $d3Dtl.default).newLozenge,
        componentProps: {
            appearance: 'new'
        }
    },
    ["new_bold"]: {
        label: (0, $d3Dtl.default).newLozenge,
        componentProps: {
            appearance: 'new',
            isBold: true
        }
    },
    ["try"]: {
        label: (0, $d3Dtl.default).tryLozenge,
        componentProps: {
            appearance: 'new'
        }
    }
};
const $53dd823c995635cb$var$styles = {
    fadeIn: "_qtt8glyw _1bsb1osq",
    itemDescription: "_1reo15vq _18m915vq _1e0c1ule _2hwxxy5q _1bto1l2s",
    titleWrapper: "_1e0c1ule",
    hasDescription: "_19pk1i6y"
};
const $53dd823c995635cb$var$SwitcherItem = ({ icon: icon, description: description, elemAfter: elemAfter, shouldAllowMultiline: shouldAllowMultiline, onClick: onClick, children: children, lozenges: lozenges, product: product, createAnalyticsEvent: createAnalyticsEvent, tag: tag, href: href, ...rest })=>{
    const itemDescription = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useMemo(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(description) || typeof description === 'string') return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
            className: (0, $35pXk.default)([
                $53dd823c995635cb$var$styles.itemDescription
            ]),
            children: description
        });
        return undefined;
    }, [
        description
    ]);
    const renderLozenges = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useMemo(()=>{
        if (!lozenges?.length) return null;
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $f8Iqd.default), {
            product: product,
            triggerSubject: "switcherItemLozengeErrorBoundary",
            hideFallbackUI: true,
            children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                children: [
                    lozenges.map((lozenge, index)=>{
                        const { componentProps: componentProps, label: label } = $53dd823c995635cb$var$lozengeData[lozenge];
                        return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                            style: {
                                marginLeft: "var(--ds-space-100, 8px)"
                            },
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5nBzc.default), {
                                ...componentProps,
                                testId: "switcher-item-lozenge",
                                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                                    ...label
                                })
                            })
                        }, index);
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a3xa0.RenderTracker), {
                        subject: (0, $a3xa0.SWITCHER_ITEM_LOZENGES_SUBJECT),
                        data: {
                            product: product,
                            lozenges: lozenges,
                            children: children,
                            description: description
                        }
                    })
                ]
            })
        });
    }, [
        lozenges,
        product,
        children,
        description
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hhh77.FadeIn), {
        tag: tag,
        className: (0, $35pXk.default)([
            $53dd823c995635cb$var$styles.fadeIn
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cGtPE.default), {
            testId: "switcher-base-item",
            description: itemDescription,
            iconBefore: icon,
            shouldTitleWrap: false,
            shouldDescriptionWrap: false,
            iconAfter: elemAfter,
            target: "_blank",
            href: href ?? '#',
            onClick: (event)=>{
                // To prevent the page from reloading when using a fallback '#' in href, make sure to use preventDefault.
                if (!href) event.preventDefault();
                if (onClick) onClick(event);
            },
            ...rest,
            children: /*#__PURE__*/ (0, $7UHDa.jsxs)("span", {
                className: (0, $35pXk.default)([
                    $53dd823c995635cb$var$styles.titleWrapper,
                    itemDescription && $53dd823c995635cb$var$styles.hasDescription
                ]),
                children: [
                    children,
                    renderLozenges
                ]
            })
        })
    });
};
var $53dd823c995635cb$export$2e2bcd8739ae039 = $53dd823c995635cb$var$SwitcherItem;

});


parcelRegister("fJvXe", function(module, exports) {

$parcel$export(module.exports, "SectionContainer", () => $1407d3a7b9c1a0d6$export$be4c8679ebfd988);
/* section-container.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $gdv5Z = parcelRequire("gdv5Z");

var $bP2lm = parcelRequire("bP2lm");

var $a3xa0 = parcelRequire("a3xa0");

var $hhh77 = parcelRequire("hhh77");

var $eCKH3 = parcelRequire("eCKH3");

var $dcO0p = parcelRequire("dcO0p");

var $7hXDW = parcelRequire("7hXDW");

var $eycgM = parcelRequire("eycgM");
const $1407d3a7b9c1a0d6$var$styles = {
    sectionBase: "_ca0q12x7 _u5f3idpf _n3td12x7 _19bvidpf",
    sectionVisualRefresh: "_1reo15vq _18m915vq _x3dozgxb _ca0qu2gc _19pk1n1a",
    list: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _2mzuglyw",
    box: "_18u0u2gc _2hwxu2gc _19pkidpf _otyru2gc",
    titleBase: "_1reo15vq _18m915vq _11c81o8v _1bto1l2s _1p1dangw _o5721q9c _19pkpxbi _18u0u2gc _syaz1gjq _k48pmoej _otyr1b66",
    titleRefresh: "_1reo15vq _18m915vq _19pk12x7 _18u0u2gc _otyr12x7 _1bto1l2s _o5721q9c _syaz131l _k48p1wq8"
};
const $1407d3a7b9c1a0d6$export$7bb82566a1f2a4f5 = ({ title: title })=>{
    const isVisualRefreshEnabled = (0, $eycgM.useIsSwitcherTeam25TestCohort)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7hXDW.default), {
        as: "h2",
        size: "xxsmall",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
            xcss: isVisualRefreshEnabled ? $1407d3a7b9c1a0d6$var$styles.titleRefresh : $1407d3a7b9c1a0d6$var$styles.titleBase,
            children: title
        })
    });
};
const $1407d3a7b9c1a0d6$var$SectionContainerComponent = ({ sectionId: sectionId, title: title, titleLink: titleLink, children: children, actionSubject: actionSubject, sectionRole: sectionRole, ariaLabel: ariaLabel, xcss: xcss })=>{
    const isVisualRefreshEnabled = (0, $eycgM.useIsSwitcherTeam25TestCohort)();
    const hasChildren = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.toArray(children).some(Boolean);
    if (!hasChildren) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)("section" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- required with `xcss`
    , {
        className: (0, $35pXk.default)([
            $1407d3a7b9c1a0d6$var$styles.sectionBase,
            isVisualRefreshEnabled && $1407d3a7b9c1a0d6$var$styles.sectionVisualRefresh,
            xcss
        ]),
        "data-testid": `${sectionId}__section`,
        role: sectionRole,
        "aria-label": ariaLabel,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gdv5Z.default), {
            xcss: isVisualRefreshEnabled && $1407d3a7b9c1a0d6$var$styles.box,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $hhh77.FadeIn), {
                    children: [
                        title && /*#__PURE__*/ (0, $7UHDa.jsx)($1407d3a7b9c1a0d6$export$7bb82566a1f2a4f5, {
                            title: title
                        }),
                        titleLink && /*#__PURE__*/ (0, $7UHDa.jsx)($1407d3a7b9c1a0d6$var$TitleLink, {
                            titleLink: titleLink,
                            actionSubject: actionSubject
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("ul", {
                    className: (0, $35pXk.default)([
                        $1407d3a7b9c1a0d6$var$styles.list
                    ]),
                    children: children
                })
            ]
        })
    });
};
const $1407d3a7b9c1a0d6$var$TitleLink = ({ titleLink: titleLink, actionSubject: actionSubject })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $a3xa0.NavigationAnalyticsContext), {
        data: (0, $a3xa0.getItemAnalyticsContext)(0, titleLink.key, (0, $dcO0p.AnalyticsItemType).PRODUCT, titleLink.productType),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eCKH3.default), {
            href: titleLink.href,
            iconAfter: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bP2lm))), {
                LEGACY_size: "small",
                color: "currentColor",
                label: ""
            }),
            label: titleLink.label,
            testId: "section-title__link",
            actionSubject: actionSubject,
            ariaLabel: titleLink.ariaLabel
        })
    }, titleLink.key);
const $1407d3a7b9c1a0d6$export$be4c8679ebfd988 = (0, $a3xa0.withAnalyticsContextData)((props)=>(0, $a3xa0.analyticsAttributes)({
        group: props.sectionId,
        groupItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.toArray(props.children).filter((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement).length
    }))($1407d3a7b9c1a0d6$var$SectionContainerComponent); /* eslint-enable */ 

});
parcelRegister("eCKH3", function(module, exports) {

$parcel$export(module.exports, "default", () => $c38c91c3d8ce7826$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $eEA8O = parcelRequire("eEA8O");

var $bP2lm = parcelRequire("bP2lm");

var $1DWH0 = parcelRequire("1DWH0");

var $7TH2w = parcelRequire("7TH2w");

var $a3xa0 = parcelRequire("a3xa0");

var $4jR19 = parcelRequire("4jR19");
const $c38c91c3d8ce7826$var$ItemLink = ({ label: label, href: href, testId: testId, onClick: onClick, ariaLabel: ariaLabel })=>{
    const buttonProps = {
        appearance: 'link',
        href: href,
        className: 'section-link',
        target: '_blank',
        rel: 'noopener noreferrer',
        iconAfter: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bP2lm))), {
            LEGACY_size: "small",
            color: "currentColor",
            label: ""
        }),
        onClick: onClick ? (e, a)=>onClick(e, a) : undefined,
        testId: testId
    };
    if (ariaLabel) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
        ...ariaLabel,
        children: (placeholder)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $eEA8O.default), {
                ...buttonProps,
                "aria-label": String(placeholder),
                children: label
            })
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eEA8O.default), {
        ...buttonProps,
        children: label
    });
};
var $c38c91c3d8ce7826$export$2e2bcd8739ae039 = (0, $1DWH0.default)({
    onClick: (0, $a3xa0.createAndFireNavigationEvent)({
        eventType: (0, $7TH2w.UI_EVENT_TYPE),
        action: 'clicked',
        actionSubject: (0, $a3xa0.SWITCHER_ITEM_SUBJECT)
    })
})($c38c91c3d8ce7826$var$ItemLink);

});



//# sourceMappingURL=atlassian-switcher.6e610bf8.js.map
